import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import ParsedFormattedMessage from '@utils/miscellaneous/react-intl-utlis';
// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import externalEndpoints from '@constants/configs/externalEndpoints';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IExchangeProgramNames, SsapData } from '../../../SsapTypes';

interface IClaimNoticeAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    exchangeAndProgramNames: IExchangeProgramNames,
    formName: string,
    stateCode: string
}


const ClaimNoticeAttestation = (props: IClaimNoticeAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            claimNoticeDMAHSAcknowledgment
        },
        exchangeAndProgramNames,
        formName,
        stateCode
    } = props;
    
    const { exchangeMedicaid } = exchangeAndProgramNames;
    const anchorLinkText = externalEndpoints[`${stateCode}_LINKS`]?.CLAIM_NOTICE_LINK;
    
    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <ParsedFormattedMessage
                            id = 'ssap.sign_and_review.claim_notice'
                            values={{
                                exchangeMedicaid,
                                asterisk: <span className='required-true'></span>,
                                link: (
                                    <a
                                        className = 'usa-link--external'
                                        href={anchorLinkText}
                                        target = '_blank'
                                        rel = 'noopener noreferrer'
                                    >
                                        <FormattedMessage
                                            id = 'ssap.sign_and_review.claim_notice_link_text'
                                            values={{ anchorLinkText}}
                                        />
                                    </a>
                                )
                            } }
                        />
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                classes: [ 'disp-styl' ],
                type: INPUT_TYPES.CHECKBOX,
                name: 'claimNoticeDMAHSAcknowledgment',
                checked: claimNoticeDMAHSAcknowledgment,
                value: claimNoticeDMAHSAcknowledgment,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ ]
            }}
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default ClaimNoticeAttestation;